export const REPEAT_TYPE = {
    NEVER: 'never',
    DAILY: 'daily',
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    YEARLY: 'yearly',
}
